const SITE_NAME = 'JustBank'

export const getTitle = title => (title ? `${title} | ${SITE_NAME}` : SITE_NAME)
